<div class="cpcontent">
    <h2>Where am I?</h2>
    <button (click)="getLocation()">Click here</button>
    <div id="map" #map style="width:100%;height:400px"></div>
</div>
